export enum ConfigurationType {
    BOOLEAN = 'BOOLEAN',
    NUMBER = 'NUMBER',
    STRING = 'STRING',
}

export const ConfigurationTypeNameMap = {
    [ConfigurationType.BOOLEAN]: 'Логический',
    [ConfigurationType.NUMBER]: 'Число',
    [ConfigurationType.STRING]: 'Строка',
}

export interface ConfigurationView {
    id: number;
    name: string;
    description: string;
    type: ConfigurationType;
    value: string;
    updatedAt: string | null;
    updatedByLogin: string;
}

export interface ConfigurationUpdateRequest {
    value: string;
}
